import { message, PageHeader, Spin, Upload, Row, Col } from "antd";
import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import {
  Form,
  FormItem,
  TableItem,
  ButtonItem,
  cuentaMask,
} from "../../../../Components/Items";
import { UploadOutlined } from "@ant-design/icons";
import * as XLSX from "xlsx";

const MONEDA_MXN_ID = "60c7e4396465ad440c41c15a";

class ImportarCuentasContables extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    archivosExcel: [],
    data: [],
    archivoError: null,
    todasAgrupadorSat: [],
    cuentasExistentes: new Set(),
  };

  componentDidMount() {
    this.setState({ loading: true });
    Promise.all([
      axios.post("agrupadorsat/selectAgrupadorSat", null, {
        headers: this.props.headersToken,
      }),
      axios.post(
        "cuentascontables/selectTodasCuentasContables",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      ),
    ]).then(([resAgrupadores, resCuentas]) => {
      const nuevoEstado = { loading: false };
      if (resAgrupadores.data.status !== 404) {
        nuevoEstado.todasAgrupadorSat = resAgrupadores.data;
      }
      if (resCuentas.data.status !== 404 && Array.isArray(resCuentas.data)) {
        nuevoEstado.cuentasExistentes = new Set(
          resCuentas.data.map(
            (c) =>
              (c.nivel1 || "") +
              (c.nivel2 || "") +
              (c.nivel3 || "") +
              (c.nivel4 || "") +
              (c.nivel5 || "")
          )
        );
      }
      this.setState(nuevoEstado);
    });
  }

  atras() {
    this.props.history.goBack();
  }

  onFinishFailed() {
    message.error("Revisa que los datos sean correctos");
  }

  onFinish(values) {
    this.setState({ loading: true });
    axios
      .post(
        "cuentascontables/importarCuentasContables",
        { ...values, empresaId: this.props.empresaId, data: this.state.data },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success(
            "Se importaron " + res.data.numero + " cuentas contables"
          );
          if (res.data.repetidos) {
            message.warning(
              "No se importaron " +
                res.data.repetidos +
                " cuentas ya que estaban repetidas"
            );
          }
          this.atras();
        } else if (res.data.success === 1) {
          message.error("No se pueden importar las cuentas");
        } else {
          message.error("Hubo un error y las cuentas no se importaron");
        }
      });
  }

  async onChangeArchivo(e) {
    this.setState({ loading: true });
    if (
      e.file.type ===
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ) {
      this.setState({
        archivosExcel: [
          {
            ...e.file,
            name: e.file.name,
            status: "uploading",
            response: "Cargando",
          },
        ],
      });
      this.cargarArchivoExcel(e.file);
    } else {
      message.error("El archivo debe ser un archivo de Excel");
      this.setState({ loading: false });
    }
  }

  descargarArchivoErrores() {
    let wbout = XLSX.write(this.state.archivoError, {
      bookType: "xlsx",
      type: "binary",
    });
    const s2ab = (s) => {
      let buf = new ArrayBuffer(s.length);
      let view = new Uint8Array(buf);
      for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
      return buf;
    };
    let a = document.createElement("a");
    document.body.appendChild(a);
    a.style = "display: none";
    const blob = new Blob([s2ab(wbout)], { type: "application/octet-stream" });
    let url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = "errores_cuentas.xlsx";
    a.click();
    window.URL.revokeObjectURL(url);
  }

  cargarArchivoExcel(file) {
    let reader = new FileReader();
    reader.readAsArrayBuffer(file);
    reader.onloadend = (e) => {
      let data = new Uint8Array(e.target.result);
      let workbook = XLSX.read(data, { type: "array" });
      let hoja1 = XLSX.utils.sheet_to_row_object_array(
        workbook.Sheets[workbook.SheetNames[0]]
      );
      this.archivoVerificar(hoja1).then((dataReturn) => {
        if (dataReturn.errores === 0) {
          this.setState({
            archivosExcel: [{ ...file, name: file.name, status: "success" }],
            data: dataReturn.objeto,
          });
        } else {
          this.setState({
            archivosExcel: [
              {
                ...file,
                name: file.name,
                status: "success",
                response: "Con errores",
              },
            ],
            archivoError: dataReturn.archivoErrores,
            data: dataReturn.objeto,
          });
          message.error(
            "Se han detectado " + dataReturn.errores + " errores"
          );
          message.info(
            "Solo se importarán los registros correctos: " +
              dataReturn.objeto.length
          );
        }
        this.setState({ loading: false });
      });
    };
  }

  async archivoVerificar(data) {
    let errores = 0;
    const archivoEditar = XLSX.utils.book_new();
    const arrayErrores = [];
    let objeto = [];

    await Promise.all(
      data.map(async (fila) => {
        let mensajeErrores = null;
        let erroresFila = 0;
        const rowNum = fila["__rowNum__"] + 1;

        const agrupadorSatStr = fila["Agrupador SAT"]
          ? `${fila["Agrupador SAT"]}`.trim()
          : undefined;
        const nivel1Raw =
          fila["Nivel 1"] !== undefined && fila["Nivel 1"] !== ""
            ? `${fila["Nivel 1"]}`.trim()
            : undefined;
        const nivel2Raw =
          fila["Nivel 2"] !== undefined && fila["Nivel 2"] !== ""
            ? `${fila["Nivel 2"]}`.trim()
            : undefined;
        const nivel3Raw =
          fila["Nivel 3"] !== undefined && fila["Nivel 3"] !== ""
            ? `${fila["Nivel 3"]}`.trim()
            : undefined;
        const nivel4Raw =
          fila["Nivel 4"] !== undefined && fila["Nivel 4"] !== ""
            ? `${fila["Nivel 4"]}`.trim()
            : undefined;
        const nivel5Raw =
          fila["Nivel 5"] !== undefined && fila["Nivel 5"] !== ""
            ? `${fila["Nivel 5"]}`.trim()
            : undefined;
        const descripcion = fila["Descripcion"]
          ? `${fila["Descripcion"]}`.trim()
          : undefined;

        const nivel1Str = nivel1Raw
          ? nivel1Raw.padStart(3, "0")
          : undefined;
        const nivel2Str = nivel2Raw
          ? nivel2Raw.padStart(2, "0")
          : undefined;
        const nivel3Str = nivel3Raw
          ? nivel3Raw.padStart(3, "0")
          : undefined;
        const nivel4Str = nivel4Raw
          ? nivel4Raw.padStart(3, "0")
          : undefined;
        const nivel5Str = nivel5Raw
          ? nivel5Raw.padStart(3, "0")
          : undefined;

        const error = (msg) => {
          errores++;
          erroresFila++;
          mensajeErrores = mensajeErrores
            ? mensajeErrores + `, ${msg}`
            : msg;
        };

        if (!agrupadorSatStr) error("Agrupador SAT está vacío");
        if (!nivel1Str) error("Nivel 1 está vacío");
        if (!descripcion) error("Descripcion está vacía");

        if (nivel1Str && !/^\d{3}$/.test(nivel1Str))
          error("Nivel 1 debe tener exactamente 3 dígitos");
        if (nivel2Str && !/^\d{2}$/.test(nivel2Str))
          error("Nivel 2 debe tener exactamente 2 dígitos");
        if (nivel3Str && !/^\d{3}$/.test(nivel3Str))
          error("Nivel 3 debe tener exactamente 3 dígitos");
        if (nivel4Str && !/^\d{3}$/.test(nivel4Str))
          error("Nivel 4 debe tener exactamente 3 dígitos");
        if (nivel5Str && !/^\d{3}$/.test(nivel5Str))
          error("Nivel 5 debe tener exactamente 3 dígitos");

        if (nivel3Str && !nivel2Str) error("Nivel 3 requiere Nivel 2");
        if (nivel4Str && !nivel3Str) error("Nivel 4 requiere Nivel 3");
        if (nivel5Str && !nivel4Str) error("Nivel 5 requiere Nivel 4");

        let agrupadorSatId = undefined;
        if (agrupadorSatStr) {
          const agrupador = this.state.todasAgrupadorSat.find(
            (a) => `${a.codigo}`.trim() === agrupadorSatStr
          );
          if (!agrupador) {
            error(`Agrupador SAT "${agrupadorSatStr}" no existe`);
          } else {
            agrupadorSatId = agrupador._id;
          }
        }

        let cuenta = nivel1Str || "";
        if (nivel2Str) cuenta += nivel2Str;
        if (nivel3Str) cuenta += nivel3Str;
        if (nivel4Str) cuenta += nivel4Str;
        if (nivel5Str) cuenta += nivel5Str;

        if (this.state.cuentasExistentes.has(cuenta))
          error(`La cuenta ${cuentaMask(cuenta)} ya existe`);

        if (erroresFila === 0) {
          objeto.push({
            agrupadorSatId,
            agrupadorSat: agrupadorSatStr,
            cuenta,
            descripcion,
            monedaId: MONEDA_MXN_ID,
            cuentaIva: false,
          });
        } else {
          arrayErrores.push({
            Errores: mensajeErrores,
            Fila: rowNum,
            ...fila,
          });
        }
        return null;
      })
    );

    const hoja = XLSX.utils.json_to_sheet(arrayErrores);
    XLSX.utils.book_append_sheet(archivoEditar, hoja, "Hoja Errores");
    return { objeto, errores, archivoErrores: archivoEditar };
  }

  descargarPlantillaImportar() {
    const wb = XLSX.utils.book_new();

    const ws1 = XLSX.utils.aoa_to_sheet([
      [
        "Agrupador SAT",
        "Nivel 1",
        "Nivel 2",
        "Nivel 3",
        "Nivel 4",
        "Nivel 5",
        "Descripcion",
      ],
    ]);
    XLSX.utils.book_append_sheet(wb, ws1, "Cuentas");

    const agrupadoresData = this.state.todasAgrupadorSat.map((a) => ({
      Codigo: a.codigo,
      Tipo: a.tipo,
      Subtipo: a.subtipo || "",
      Descripcion: a.descripcion,
    }));
    const ws2 = XLSX.utils.json_to_sheet(agrupadoresData);
    XLSX.utils.book_append_sheet(wb, ws2, "Agrupadores SAT");

    XLSX.writeFile(wb, "plantillaCuentasContables.xlsx");
  }

  render() {
    const columns = [
      {
        title: "Agrupador SAT",
        dataIndex: "agrupadorSat",
        key: "agrupadorSat",
        width: 130,
      },
      {
        title: "Código",
        dataIndex: "cuenta",
        key: "cuenta",
        width: 180,
        render: (v) => cuentaMask(v),
      },
      {
        title: "Descripción",
        dataIndex: "descripcion",
        key: "descripcion",
      },
    ];

    return (
      <>
        <PageHeader
          onBack={this.atras.bind(this)}
          title="Importar Cuentas Contables"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            this.state.archivoError ? (
              <ButtonItem onClick={this.descargarArchivoErrores.bind(this)}>
                Descargar Errores
              </ButtonItem>
            ) : null
          }
        />
        <div className="card-background" style={{ paddingTop: 5 }}>
          <Spin
            spinning={this.state.loading}
            tip="Cargando valores, espere por favor"
          >
            <Form
              ref={this.formRef}
              name="importarCuentasContables"
              layout
              bottom={
                <ButtonItem
                  type="primary"
                  htmlType="submit"
                  style={{ display: "block", margin: "0 0 0 auto" }}
                >
                  Importar
                </ButtonItem>
              }
              onFinish={this.onFinish.bind(this)}
              onFinishFailed={this.onFinishFailed}
            >
              <Row style={{ marginTop: 20 }}>
                <Col
                  span={12}
                  xs={24}
                  sm={24}
                  lg={12}
                  xl={12}
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <ButtonItem
                    onClick={() => this.descargarPlantillaImportar()}
                    type="primary"
                  >
                    Descargar Plantilla
                  </ButtonItem>
                </Col>
                <Col span={12} xs={24} sm={24} lg={12} xl={12}>
                  <FormItem name="archivo" label="Archivo">
                    <Upload
                      showUploadList={{
                        showRemoveIcon: false,
                        showPreviewIcon: false,
                      }}
                      fileList={this.state.archivosExcel}
                      customRequest={this.onChangeArchivo.bind(this)}
                      accept=".xlsx"
                    >
                      <ButtonItem icon={<UploadOutlined />}>Subir</ButtonItem>
                    </Upload>
                  </FormItem>
                </Col>
              </Row>
            </Form>
            <TableItem
              size="small"
              dataSource={this.state.data}
              columns={columns}
              scroll={{ x: "max-content" }}
            />
          </Spin>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(ImportarCuentasContables);